<template>
  <div class="qa-item-thread-navigation">
    <app-button
      type="outlined"
      variant="neutral"
      data-locator="previous-question-button"
      :disabled="!question.previousInRoom"
      @click="() => getQuestion(question.previousInRoom)"
    >
      <template #left-icon>
        <app-material-icon name="keyboard_arrow_left" size="xs" class="mr-2" />
      </template>
      {{ $t('project.question-answer.QuestionAnswerItemThreadNavigation.previousLabel') }}
    </app-button>

    <app-button
      type="outlined"
      variant="neutral"
      :to="{ name: QUESTION_ANSWER_LIST_ROUTE_NAME }"
      data-locator="back-qa-button"
    >
      {{ $t("project.question-answer.QuestionAnswerItemThreadNavigation.headerGoToQuestionList") }}
    </app-button>

    <app-button
      type="outlined"
      variant="neutral"
      :disabled="!question.nextInRoom"
      data-locator="next-question-button"
      @click="() => getQuestion(question.nextInRoom)"
    >
      {{ $t('project.question-answer.QuestionAnswerItemThreadNavigation.nextLabel') }}
      <template #right-icon>
        <app-material-icon name="keyboard_arrow_right" size="xs" class="ml-2" />
      </template>
    </app-button>
  </div>
</template>

<script>
import { QUESTION_ANSWER_ITEM_ROUTE_NAME, QUESTION_ANSWER_LIST_ROUTE_NAME } from '@/router/routerData'

export default {
  name: 'QuestionAnswerItemThreadNavigation',
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      QUESTION_ANSWER_LIST_ROUTE_NAME,
    }
  },
  methods: {
    getQuestion (questionId) {
      this.$router.push({
        name: QUESTION_ANSWER_ITEM_ROUTE_NAME,
        params: {
          questionId: questionId,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.qa-item-thread-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  gap: 12px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    flex-wrap: wrap;

    .app-button {
      width: 100%;
    }
  }
}
</style>
